import './common/base';
import Vue from './vue/common/vue-common';
import Livelo from './vue/components/livelo/Livelo.vue';

new Vue({
    el: '#itau',
    template: '<Livelo/>',
    components: { Livelo },
});
